<script>
import FeedbackButtons from '@modules/aawz-intelligence-v2/components/feedback-buttons/feedback-buttons.vue'

export default {
  name: 'IntelligenceV2ChatMessageFooter',
  components: {
    FeedbackButtons,
  },
  props: {
    isStreaming: {
      type: Boolean,
      default: false,
    },
    messageId: {
      type: [String, Number],
      default: null,
    },
    currentFeedback: {
      type: String,
      default: null,
    },
    // [spec-011 T003] Comentário já persistido do feedback desta mensagem —
    // repassado ao `FeedbackButtons` para exibir na reabertura da conversa.
    currentComentario: {
      type: String,
      default: null,
    },
  },
  methods: {
    onFeedback(payload) {
      this.$emit('feedback', payload)
    },
  },
}
</script>

<template>
  <!-- Rodape: a barra de acoes da mensagem (hoje so o feedback). -->
  <div class="chat-message-footer mt-2">
    <!-- [11/09/2026] O rodapé deixou de ter STATUS: o "W" animado + o rótulo
         de fase ("Pensando...") que viviam aqui migraram para a linha única
         de raciocínio (`raciocinio-linha`, no topo da bolha) — o usuário
         pediu UM indicador por turno. Durante o streaming o rodapé não
         desenha nada; depois, só o feedback. -->
    <div
      v-if="!isStreaming && messageId"
      class="chat-message-footer__actions d-flex align-center"
    >
      <FeedbackButtons
        :message-id="messageId"
        :current-feedback="currentFeedback"
        :current-comentario="currentComentario"
        @feedback="onFeedback"
      />
    </div>
  </div>
</template>

<style lang="sass" scoped>
.chat-message-footer
  min-height: 18px

.chat-message-footer__actions
  gap: 8px
</style>
